<ng-container *ngIf="pier?.id">
    <ng-container *ngIf="disableLink; else withLink">
        <span [attr.data-test]="dataTest">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Steg kann nicht identifiziert werden!">
                    <em>Keine Bezeichnung</em>
                </abbr>
            </ng-template>
        </span>
    </ng-container>
    <ng-template #withLink>
        <a (click)="click($event)"
           [attr.data-test]="dataTest"
           [bcmRouterLink]="['piers', pier.id]">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Steg kann nicht identifiziert werden!">
                    <em>Keine Bezeichnung</em>
                </abbr>
            </ng-template>
        </a>
    </ng-template>
</ng-container>
